import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/providers/services/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: false,
})
export class CallbackComponent implements OnInit {
  constructor(
    public authentictionService: AuthenticationService,
    public router: Router
  ) {}

  async ngOnInit() {
    if (environment.isPkceFlowMode) {
      const auth0pkceclient =
        await this.authentictionService.getAuth0PkceClient();
      const result = await auth0pkceclient.handleRedirectCallback();
      const targetRoute =
        result.appState && result.appState.target ? result.appState.target : '';

      this.authentictionService.Authenticated.next(
        await auth0pkceclient.isAuthenticated()
      ); // Update observables
      this.authentictionService.profile.next(await auth0pkceclient.getUser());

      this.router.navigate([targetRoute]);
    }
  }
}
